import * as GuardiansV2API from "@/services/api/guardiansv2";
import type {
  AuditableEntityKind,
  AuditableEntityRow,
} from "@/services/api/guardiansv2/types";

/** Default search adapter for Guardians auditable entities. */
export async function defaultGuardiansEntitySearch(
  query: string,
  kinds: AuditableEntityKind[]
): Promise<AuditableEntityRow[]> {
  const trimmed = query.trim();
  if (!trimmed) return [];
  const result = await GuardiansV2API.searchAuditableEntities({
    q: trimmed,
    kinds,
    limit: 30,
  });
  return result.entities;
}
